/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
import { VApplication } from "../../application";
import { LoggerModule } from "@vlinder-web/logger-module-react";
import { getAgent } from "./agent";
import { IModifyOrderArgs } from "./components";

const is = require("is_js");

const SERVICE_NAME = "ChangeCostumeOptionsPageService";
const log: any = LoggerModule.getInstance();

export class ChangeCostumeOptionsPageService {
  private static instance: ChangeCostumeOptionsPageService;
  private vapp: VApplication;
  private selectedCostume: any;

  private constructor(props: any = {}) {
    this.vapp = VApplication.getInstance();
  }

  public static getInstance(props: any = {}): ChangeCostumeOptionsPageService {
    if (!ChangeCostumeOptionsPageService.instance) {
      ChangeCostumeOptionsPageService.instance =
        new ChangeCostumeOptionsPageService(props);
    }
    return ChangeCostumeOptionsPageService.instance;
  }

  public setSelectedCostume(data: any) {
    console.log(data)
    this.selectedCostume = data;
  }

  public getSelectedCostume() {
    console.log(this.selectedCostume)
    return this.selectedCostume;
  }

  public getStaticPageContent() {
    let content: any = {};
    let compProps: any = null;
    const agent = getAgent();

    compProps = agent.getStaticPageContentSync({});
    if (compProps) {
      content = { ...content, ...compProps };
    }

    return content;
  }

  public async getCostumeType(payload: any) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.getCostumeType(payload);

    return content;
  }

  public async modifyOrder(payload: IModifyOrderArgs) {
    let content: any = {};
    const agent = getAgent();

    content = await agent.modifyOrder(payload);

    return content;
  }
}
